import React from 'react';
import { useAdminConfig } from '../../hooks/useAdminConfig';
import { Card } from '../../components/ui/Card';
import { RolesPermissionsMatrix } from '../../components/admin/RolesPermissionsMatrix';
import { LoadingSpinner } from '../../components/ui/Feedback';
import { Key } from 'lucide-react';

export const RolesPermissionsPage: React.FC = () => {
  const { rolesPermissions, isLoading, updateRolePermissions } = useAdminConfig();

  if (isLoading) return <LoadingSpinner size="lg" text="Loading Roles & Permissions..." />;

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold text-slate-100 flex items-center gap-2">
          <Key className="w-5 h-5 text-sky-400" />
          Roles & Permissions Matrix
        </h3>
        <p className="text-xs text-slate-400">Configure role-based access control permissions</p>
      </div>

      <Card title="Permission Matrix">
        <RolesPermissionsMatrix
          rolesPermissions={rolesPermissions}
          onUpdate={updateRolePermissions}
        />
      </Card>
    </div>
  );
};
